<template>
    <div class="question-item">
        <transition name="van-fade">
            <div v-show="(showQuestion && showQuestion.id === question.id) || show" class="question-title">
                <TextTemplate :text="`${question.indexNo}. ${question.content}`" />
            </div>
        </transition>
        <ImagePreview :picUrl="question.picUrl" v-if="question.picUrl" />
        <Result :question="question" />
    </div>
</template>
<script>
import TextTemplate from '../../TextTemplate.vue'
import ImagePreview from '../../ImagePreview.vue'
import Result from '../Result.vue'

export default {
    computed: {
        showQuestion() {
            const state = this.$store.state.paperResult
            if (state.currentSubQuestion) return state.currentSubQuestion
            if (state.currentQuestion) return state.currentQuestion
            return null
        },
    },
    components: { TextTemplate, Result, ImagePreview },
    props: ['question', 'show'],
}
</script>
